module.exports = __webpack_public_path__ + "img/mauritius.5a1c8afc.jpg";